<template>
  <div class="c-masthead-two">
    <div class="c-masthead-two__inner">
      <div class="left">
        <sc-text tag="h1" v-if="fields && fields.heading" :field="fields.heading" />
        <sc-text tag="h3" v-if="fields && fields.subheading" :field="fields.subheading" />
        <sc-text
          tag="p"
          v-if="fields && fields.lead"
          :field="fields.lead"
          class="c-masthead-two__lead"
        />
        <sc-link
          v-if="fields && fields.cta && fields.cta.value.text"
          :field="fields.cta"
          class="c-masthead-two__cta"
          :class="fields.cta.value.class"
        />
      </div>
      <div class="right">
        <sc-text tag="h3" v-if="fields && fields.listheading" :field="fields.listheading" />
        <div class="links">
          <sc-placeholder name="jss-masthead-two-column" :rendering="rendering" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Text, Link, Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Masthead-Two-Column',
  components: {
    ScText: Text,
    ScLink: Link,
    ScPlaceholder: Placeholder
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    },
    rendering: {
      type: Object
    }
  }
};
</script>
<style lang="scss" scoped>
.c-masthead-two {
  color: $white;
  background: linear-gradient(
    169deg,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 59, 92, 1) 20%,
    rgba(0, 134, 191, 1) 100%
  );

  &__inner {
    @include desktop-up {
      display: flex;
      @include padding-x-thin;
    }

    h1,
    h2,
    h3,
    p,
    a,
    span {
      color: $white;
    }

    h1,
    h2 {
      -webkit-text-fill-color: $white;
    }

    h1 {
      margin-top: 0;
      font-size: 3.6rem;
      line-height: 4.2rem;

      @include desktop-up {
        font-size: 5rem;
        line-height: 5.6rem;
      }
    }

    h3 {
      margin-bottom: 4rem;
      @include phone-only {
        font-size: 2rem;
        line-height: 2.6rem;
      }
    }
  }

  .left {
    padding: 4rem 2rem;

    @include tablet-up {
      padding-right: 10rem;
    }

    @include desktop-up {
      width: 60%;
      @include padding-y(10rem);
      padding-right: 16rem;
    }
  }

  .right {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 3rem 2rem;
    background-color: rgba(0, 59, 92, 0.8); //dark-blue

    @include desktop-up {
      width: 40%;
      padding: 10rem 4% 10rem 5%;
    }

    @include large-desktop-up {
      padding-left: 6%;
    }
  }

  &__lead {
    margin: 0 0 0.8rem 0;
    font-weight: 200;
    line-height: 2.6rem;
  }

  &__cta {
    position: relative;
    font-weight: 500;

    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      height: 0.1rem;
      width: 100%;
      background-color: $white;
    }
  }

  .links {
    padding-left: 3.5rem;

    @include desktop-up {
      padding-left: 2rem;
    }
  }

  &:deep() {
    .c-masthead__link {
      border-left: solid 0.2rem $orange;
      padding: 0.5rem 0 4rem 4.1rem;

      @include desktop-up {
        padding-left: 2rem;
      }

      @include large-desktop-up {
        padding-left: 4.7rem;
      }

      &:last-child {
        padding-bottom: 0.5rem;
      }

      a {
        display: flex;
        align-items: center;
        @include font-styles('Arial Narrow', 1.8rem, 400, normal, 2.2rem, 0, $white);
        text-transform: uppercase;

        &::after {
          content: '';
          position: relative;
          background-image: url(~@/assets/images/icon-arrow-right-white-mobile.svg);
          background-repeat: no-repeat;
          background-size: contain;
          margin-left: 1rem;
          width: 1.6rem;
          height: 1.2rem;
          transition: 0.25s;
          right: 0;
        }

        &:hover {
          &::after {
            content: '';
            right: -1rem;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 1580px) {
  .c-masthead-two {
    .right {
      margin-right: 7rem;
    }
  }
}
</style>
